TrelloModel = require 'models/internal/trello-model'

module.exports = class BoardStar extends TrelloModel
  typeName: 'BoardStar'
  getBoard: -> @modelCache.get 'Board', @get('idBoard')



// WEBPACK FOOTER //
// ./app/scripts/models/board-star.coffee